import { ReactNode, FC } from 'react';

type CardGridProps = {
  children: ReactNode;
};

export const CourseCardGrid: FC<CardGridProps> = ({ children }) => {
  return (
    <div
      tabIndex={-1}
      className="grid grid-cols-1 justify-center gap-x-3 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
    >
      {children}
    </div>
  );
};
